export const API_FETCH_LIMIT = 1024
export const API_PAST_VISITS_FETCH_LIMIT = 20
export const API_INTAKE_SCORES_FETCH_LIMIT = 12
export const API_PENDING_VISITS_FETCH_LIMIT = 32
